export default __webpack_public_path__ + "/assets/fonts/inter-greek-wght-normal.woff2";